export default "__VITE_ASSET__0b0d1033__"